<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Play</router-link> |
      <router-link to="/settings">Settings</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  methods: {},
  beforeMount() {
    this.$store.dispatch("init");
  },
};
</script>

<style lang="scss">
/* https://www.freecodecamp.org/news/html-page-width-height/ */
body {
  height: 100vh;
}

#app {
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif; /* 'Fjalla One' */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #0d151d;
  display: flex;
  flex-direction: column;
}

#nav {
  padding: 1rem;
  background-color: rgb(165, 205, 255);

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.search-match {
  font-weight: bold;
  color: #bbb;
}
</style>
